import React from 'react';
import Paper from 'components/paper/Paper';
import ClassNames from 'classnames';
import EnhancedSwitch from '../enhanced-switch/EnhancedSwitch';
import RadioButton from '../radio/Radio';

export default React.createClass({

	propTypes: {
		name: React.PropTypes.string.isRequired,
		className: React.PropTypes.oneOfType([
			React.PropTypes.object,
			React.PropTypes.string
		]),
		valueSelected: React.PropTypes.string,
		defaultSelected: React.PropTypes.string,
		labelPosition: React.PropTypes.oneOf(['left', 'right']),
		onChange: React.PropTypes.func
	},

	_hasCheckAttribute(radioButton) {
		return radioButton.props.hasOwnProperty('checked') &&
			radioButton.props.checked;
	},

	getInitialState() {
		return {
			numberCheckedRadioButtons: 0,
			selected: this.props.valueSelected || this.props.defaultSelected || ''
		};
	},

	componentWillMount() {
		let cnt = 0;
			React.Children.forEach(this.props.children, function(option) {
				if(React.addons.TestUtils.isElementOfType(option, RadioButton)){
					if (this._hasCheckAttribute(option)) cnt++;
				}
			}, this);


		this.setState({
			numberCheckedRadioButtons: cnt
		});
	},

	componentWillReceiveProps(nextProps) {
		if (nextProps.hasOwnProperty('valueSelected')) {
			this.setState({
				selected: nextProps.valueSelected
			});
		}
	},

	render() {

		let options = React.Children.map(this.props.children, function(option) {
			if(React.addons.TestUtils.isElementOfType(option, RadioButton)){
				let {
					name,
					value,
					label,
					onCheck
				} = option.props;

				return <RadioButton
					{...option.props}
					ref={option.props.value}
					name={this.props.name}
					key={option.props.value}
					value={option.props.value}
					label={option.props.label}
					labelPosition={this.props.labelPosition}
					onCheck={this._onChange}
					checked={option.props.value == this.state.selected} />
			} else {
				return this._checkDescendants(option);
				//return option
			}
		}, this);

		let classes = ClassNames(this.props.className);

		return (
			<div className={classes}>
				{options}
			</div>
		);

	},

	_renderRadioButtons(option) {
		let {
			name,
			value,
			label,
			onCheck
		} = option.props;

		return <RadioButton
			{...option.props}
			ref={option.props.value}
			name={this.props.name}
			key={option.props.value}
			value={option.props.value}
			label={option.props.label}
			labelPosition={this.props.labelPosition}
			onCheck={this._onChange}
			checked={option.props.value == this.state.selected} />
	},

	descendants: [],

	_setDescendants(option) {
		if(option.props !== undefined){
			React.Children.forEach(option.props.children, function (child){
				if(React.addons.TestUtils.isElementOfType(child, RadioButton)){
					this.descendants.push(child)
				} else {
					this._setDescendants(child);
				}
			},this);

			return this.descendants;
		}
	},

	_checkDescendants(component) {

		return React.Children.map(component,(child)=> {
			if(React.addons.TestUtils.isElementOfType(child, RadioButton)){

				return React.cloneElement(child, {
					onCheck: this._onChange,
					checked: child.props.value == this.state.selected,
					labelPosition: this.props.labelPosition,
					name: this.props.name
				})
			} else {
				if (React.Children.count(child) !== 0 && child.props !== undefined){
					return React.cloneElement(child, {}, this._checkDescendants(child.props.children));
				} else {
					return child;
				}

			}
		});

	},

	_updateRadioButtons(newSelection) {
		if (this.state.numberCheckedRadioButtons == 0) {
			this.setState({
				selected: newSelection
			});
		} else if (process.NODE_ENV !== 'production') {
			let message = "Cannot select a different radio button while another radio button " +
				"has the 'checked' property set to true.";
			console.error(message);
		}
	},

	_onChange(e, newSelection) {
		this._updateRadioButtons(newSelection);

		// Successful update
		if (this.state.numberCheckedRadioButtons == 0) {
			setTimeout(()=> {
				if (this.props.onChange) this.props.onChange(e, newSelection);
			}, 1);
		}
	},

	getSelectedValue() {
		return this.state.selected;
	},

	setSelectedValue(newSelection) {
		this._updateRadioButtons(newSelection);
	},

	clearValue() {
		this.setSelectedValue('');
	}

});



/** WEBPACK FOOTER **
 ** ./src/components/forms/radio-group/RadioGroup.js
 **/